import React, { Component } from 'react';
import { connect } from 'react-redux';
import Monitor from '@/components/Monitor/UploadMonitor';
import { cancelUploadWorkflow, changeDesign } from '../../SierraSider/Upload/store/action';
import designConstructor from '@/services/helper/designConstructor';
import { LAYOUT } from '../../../../constants/designType';
import '@/publicCss/style.css';
import '@/publicCss/monitorStyle.css';
import { SIERRA } from '../../../../constants/pageType';

class SimulationMonitor extends Component {

  render() {
    return (
      <Monitor
        {...this.props}
        pageType={SIERRA}
      />
    )
  }
}


const mapState = (state) => {
  const { project: { currentProjectId } } = state.SierraReducer;
  const { visible, uploadProgress, transProgress, msg, monitor, uploadProjectId,
    endMsg, uploadDesignId, uploadWorkflowId, compressProgress, currentPCBKey, designLog, openDesignId, uploadDesignName } = state.SierraReducer.SierraUploadReducer;
  /*   const { tabVisible, projectName } = state.SierraReducer.TabMonitorReducer; */
  const { projectName, tabVisible } = state.TabMonitorReducer;
  let design = designConstructor.getDesign(openDesignId) || {};
  if (design && design.projectId !== currentProjectId) {
    design = {}
  }
  let designs = currentProjectId ? designConstructor.getDesignValuesNotPreLayout(currentProjectId) : [];
  const findDesign = uploadDesignId ? designs.find(item => item.id === uploadDesignId) : null;

  if (uploadProjectId === currentProjectId && !findDesign && (visible || (uploadDesignName && ((monitor && monitor.length) || msg)))) {
    designs.push({ id: "upload", name: uploadDesignName, type: LAYOUT });
  }

  if (uploadProjectId === currentProjectId && openDesignId === "upload" && !findDesign) {
    design = { name: uploadDesignName, id: "upload", type: LAYOUT }
  }

  if (uploadDesignId && findDesign && openDesignId === "upload" && !design.id) {
    design = findDesign;
  }

  return {
    visible,
    startMsg: msg,
    uploadProgress,
    transProgress,
    compressProgress,
    monitor,
    uploadProjectId,
    endMsg,
    uploadDesignId,
    tabVisible,
    projectName,
    uploadWorkflowId,
    currentPCBKey,
    designs,
    openDesignId,
    designLog,
    uploadDesignName,
    subOptionType: "",
    subSelect: { ...design },
    subName: design.name,
    openProjectId: currentProjectId
  }
}

const mapDispatch = (dispatch) => ({
  _cancelUploadWorkflow(workflowId) {
    dispatch(cancelUploadWorkflow(workflowId));
  },
  _changeDesign(designId) {
    dispatch(changeDesign(designId))
  }
})

export default connect(mapState, mapDispatch)(SimulationMonitor);